








import { Component, Vue, Prop } from 'vue-property-decorator';
import opTableLocal from '@/components/opTableLocal.vue';
import opTableServerSide from '@/components/opTableServerSide.vue';
import { StorageServices } from '@/services/StorageServices';
import router from '@/router';
import store from '@/store';

@Component({
    components: {
        opTableLocal,
        opTableServerSide
    }
})
export default class OpTable extends Vue {
    @Prop() items: any[];
    @Prop({
        default: true
    }) showUpperPagination: boolean;
    @Prop({
        default: true
    }) showLowerPagination: boolean;
    @Prop({
        type: Number,
        default: 10
    }) itemsPerPage: number;
    @Prop({
        required: false
    }) filter: any;
    @Prop() name: string;
    @Prop({ default: () => { return {} } }) filtersFn: any;
    @Prop({
        required: false
    }) totalItemsCount: number;
    @Prop() clearFilters: number;

    search(filter){
        this.$emit("search", this.search)
    }

    component: any = null;

    opName: string = "";

    created(){
        this.opName = this.name || this.$route.path;

        if(this.filter){
            this.component = opTableServerSide;
            let filters = StorageServices.getOpTableFilters(this.opName);
            for(let p in filters){
                this.filter[p] = filters[p];
            }
        } else {
            this.component = opTableLocal;
        }

        store.state.beforeNavCbs.push((to, from, next) => {
            this.setFilters();
            next();
        })
         
        window.addEventListener('beforeunload', this.setFilters);
    }

    beforeDestroy(){
        this.setFilters();
        window.removeEventListener('beforeunload', this.setFilters);
    }

    setFilters(){
        if(this.filter){
            StorageServices.setOpTableFilters(this.opName, this.filter);
        } else {
            let opTableComponent = <Vue>this.$refs.opTableRef;
            if(!opTableComponent)
                return;
            let filters = opTableComponent.$data.filterInputs;
            let toSave = {};
            filters.forEach(x => {
                toSave[x.name] = x.value;
            });
            StorageServices.setOpTableFilters(this.opName, toSave);
        }
    }


}
